import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译资源
import zhCN from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';
import enUS from './locales/en-US.json';
import viVN from './locales/vi-VN.json';
import thTH from './locales/th-TH.json';
import msMY from './locales/ms-MY.json';
import jaJP from './locales/ja-JP.json';
import koKR from './locales/ko-KR.json';
import esES from './locales/es-ES.json';
import ptPT from './locales/pt-PT.json';

// 自定义语言检测函数
const customLanguageDetector = {
  name: 'customDetector',
  lookup() {
    const browserLang = navigator.language || navigator.userLanguage;
    
    // 特殊处理中文
    if (browserLang.startsWith('zh')) {
      // 检测繁体中文的地区代码
      if (browserLang.includes('TW') || browserLang.includes('HK') || browserLang.includes('MO')) {
        return 'zh-TW';
      }
      // 默认返回简体中文
      return 'zh-CN';
    }
    
    // 其他语言的映射
    const langMap = {
      'en': 'en-US',
      'vi': 'vi-VN',
      'th': 'th-TH',
      'ms': 'ms-MY',
      'ja': 'ja-JP',
      'ko': 'ko-KR',
      'es': 'es-ES',
      'pt': 'pt-PT'
    };
    
    const langCode = browserLang.split('-')[0];
    return langMap[langCode] || browserLang;
  }
};

const resources = {
  'zh-CN': {
    translation: zhCN
  },
  'zh-TW': {
    translation: zhTW
  },
  'en-US': {
    translation: enUS
  },
  'vi-VN': {
    translation: viVN
  },
  'th-TH': {
    translation: thTH
  },
  'ms-MY': {
    translation: msMY
  },
  'ja-JP': {
    translation: jaJP
  },
  'ko-KR': {
    translation: koKR
  },
  'es-ES': {
    translation: esES
  },
  'pt-PT': {
    translation: ptPT
  },
  // 添加简化的语言代码映射
  'zh': {
    translation: zhCN
  },
  'en': {
    translation: enUS
  },
  'vi': {
    translation: viVN
  },
  'th': {
    translation: thTH
  },
  'ms': {
    translation: msMY
  },
  'ja': {
    translation: jaJP
  },
  'ko': {
    translation: koKR
  },
  'es': {
    translation: esES
  },
  'pt': {
    translation: ptPT
  }
};

// 创建自定义的LanguageDetector实例
const languageDetector = new LanguageDetector();
languageDetector.addDetector(customLanguageDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    debug: process.env.NODE_ENV === 'development',
    
    // 支持的语言列表
    supportedLngs: [
      'zh-CN', 'zh-TW', 'en-US', 'vi-VN', 'th-TH', 'ms-MY', 'ja-JP', 'ko-KR', 'es-ES', 'pt-PT',
      'zh', 'en', 'vi', 'th', 'ms', 'ja', 'ko', 'es', 'pt'
    ],
    
    // 非严格模式，允许部分匹配
    nonExplicitSupportedLngs: true,
    
    detection: {
      // 优先使用自定义检测器，然后是localStorage，最后是浏览器默认
      order: ['localStorage', 'customDetector', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    }
  });

export default i18n;